/* T.LUXY V9 — minimalist mobile gallery progress line.
 * Listen to native slide class changes; never intercept native slider events.
 */
(() => {
  'use strict';
  function setupIndicator(indicator) {
    if (indicator.dataset.tluxyInitialized === 'true') return;
    const gallery = indicator.closest('[data-product-single-media-group]');
    const slider = gallery?.querySelector('[data-product-single-media-slider]');
    const bar = indicator.querySelector('[data-tluxy-mobile-gallery-bar]');
    if (!slider || !bar) return;
    indicator.dataset.tluxyInitialized = 'true';

    const sync = () => {
      const slides = [...slider.querySelectorAll('[data-product-slide]')];
      if (slides.length < 2) return;
      let selected = slides.findIndex(slide => slide.classList.contains('is-selected'));
      if (selected < 0) selected = slides.findIndex(slide => !slide.classList.contains('media--hidden'));
      if (selected < 0) selected = 0;
      const pct = 100 / slides.length;
      bar.style.width = `${pct}%`;
      bar.style.left = `${selected * pct}%`;
    };
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(slider, {attributes: true, attributeFilter: ['class'], subtree: true, childList: true});
    indicator._tluxyGalleryObserver = observer;
  }
  function init() {
    document.querySelectorAll('[data-tluxy-mobile-gallery-indicator]').forEach(setupIndicator);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tluxy-mobile-gallery-indicator]').forEach(indicator => {
      indicator._tluxyGalleryObserver?.disconnect();
    });
  });
})();
